import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { hubAktif, type NavHub } from '../lib/nav-hub';
import { SignOutButton } from './SignOutButton';

/**
 * Sidebar kiri desktop untuk Owner/Manajer — item 7, review 12 Sep 2026.
 *
 * SATU sumber `NAV_ITEMS`, dipakai mobile (`BottomNav` + halaman Lainnya) dan desktop (di sini) —
 * bukan daftar menu kedua yang bisa menyimpang. Sejak #1758 yang diterima adalah GRUP (`navHubs`):
 * Beranda · Laporan · Tugas · Absensi · Karyawan · Alat · Pengaturan (Laporan sejak #1760) —
 * urutan yang sama dengan bilah bawah, hanya ditampilkan seluruhnya karena di desktop tidak ada
 * batas slot.
 *
 * TIDAK dipakai Kurir/Karyawan sama sekali — `AppShell` hanya merendernya saat `oversight`, dan
 * CSS-nya (`.shell-oversight`) yang menentukan kapan ia benar-benar terlihat (≥1024px).
 *
 * `SignOutButton` DI SINI JUGA (WKF-002, #1155, audit peran 14 Sep 2026). `BottomNav` — satu-
 * satunya jalan ke halaman Lainnya yang menyimpan tombol Keluar — disembunyikan lewat CSS begitu
 * sidebar ini tampil (`.shell-oversight .bottom-nav { display: none }`, ≥1024px). Tanpa baris
 * ini, Owner/Manajer di desktop TIDAK PUNYA cara mengklik keluar dari akunnya sendiri — bukan
 * tersembunyi, betul-betul tidak terjangkau kecuali mengetik `/menu` langsung di alamat.
 */
export function Sidebar({ hubs }: { readonly hubs: readonly NavHub[] }): ReactNode {
  const { pathname } = useLocation();
  const aktif = hubAktif(hubs, pathname);

  /*
   * Satu daftar datar (#1758) — tanpa judul Saya/Operasional/Pengaturan. Dengan tujuh grup,
   * judul bagian hanya menambah baris untuk dibaca; Pengaturan sekarang sudah satu entri sendiri.
   */
  return (
    <nav className="sidebar" aria-label="Navigasi utama">
      <div className="sidebar-section">
        {hubs.map((hub) => (
          <Link
            key={hub.key}
            to={hub.to}
            className={hub.key === aktif ? 'sidebar-item active' : 'sidebar-item'}
            aria-current={hub.key === aktif ? 'page' : undefined}
          >
            {hub.label}
          </Link>
        ))}
      </div>
      <div className="sidebar-section sidebar-signout">
        <SignOutButton />
      </div>
    </nav>
  );
}
